import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchTerm", "searchFrame", "submit"]
  
  initialize() {
    this.debounceTimer = null
    this.disableSubmit()
    
    this.clickOutsideHandler = this.handleClickOutside.bind(this)
    document.addEventListener('click', this.clickOutsideHandler)
  }

  disableSubmit() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      this.submitTarget.classList.remove('cursor-pointer')
    }
  }

  enableSubmit() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
      this.submitTarget.classList.add('cursor-pointer')
    }
  }
  
  handleClickOutside(event) {
    if (!event.target || !this.element.contains(event.target)) {
      const dropdown = document.getElementById('search-dropdown')
      if (dropdown) {
        dropdown.style.display = 'none'
      }
      
      if (this.hasSearchFrameTarget) {
        this.searchFrameTarget.innerHTML = ''
      }
    }
  }

  search(event) {
    clearTimeout(this.debounceTimer)
    
    const dropdown = document.getElementById('search-dropdown')
    if (dropdown) {
      dropdown.style.display = 'flex'
    }
    
    this.debounceTimer = setTimeout(() => {
      const searchTerm = this.searchTermTarget.value.trim()
      const frame = this.searchFrameTarget
      const baseUrl = frame.dataset.requestTarget

      if (!searchTerm) {
        frame.innerHTML = ''
        this.disableSubmit()
        return
      }

      if (searchTerm.length < 2) {
        frame.innerHTML = `
          <div class="text-[#494E64] text-base leading-6 py-4">
            Please enter at least 2 characters to search
          </div>
        `;
        this.disableSubmit();
        return;
      }

      const params = new URLSearchParams({
        searchTerm: searchTerm,
        target: frame.id
      })

      frame.src = baseUrl + '?' + params.toString()
      this.enableSubmit()
    }, 500)  
  }

  disconnect() {
    clearTimeout(this.debounceTimer)
    document.removeEventListener('click', this.clickOutsideHandler)
    
    const dropdown = document.getElementById('search-dropdown')
    if (dropdown) {
      dropdown.style.display = 'none'
    }
    
    if (this.hasSearchFrameTarget) {
      this.searchFrameTarget.innerHTML = ''
    }
    
    if (this.hasSearchTermTarget) {
      this.searchTermTarget.value = ''
    }

    this.disableSubmit()
  }
}